<template>
  <div id="app" :id="isMobile ? 'app-m' : 'app'">
    <div v-if="isMobile" style="width: 100%; height: 120px"></div>
    <div v-else style="width: 100%; height: 106px"></div>

    <div class="app-head-bg">
      <div class="l-k"></div>
      <div class="app-header">
        <div class="logo">
          <img src="./assets/logo.png" alt="" />
        </div>
        <div class="menu-box">
          <router-link class="menu" to="/">
            <div>首页</div>
            <div class="xian" v-if="nowPath == '/'"></div>
          </router-link>
          <div class="menu men-c" to="/chanpin">
            <div>产品中心</div>
            <div class="xian" v-if="nowPath == '/chanpin'"></div>
            <div class="chanpin">
              <router-link class="menu-child" to="/ruanjian"
                >软件产品</router-link
              >
              <router-link class="menu-child" to="/yingjian"
                >硬件产品</router-link
              >
              <router-link class="menu-child" to="/hujiao"
                >呼叫中心</router-link
              >
              <router-link class="menu-child" to="/zhengjian"
                >证件印制制作</router-link
              >
              <router-link class="menu-child" to="/shuju"
                >数据分析报告</router-link
              >
              <router-link class="menu-child" to="/renyuan"
                >人员服务</router-link
              >
            </div>
          </div>
          <!-- <router-link class="menu" to="/yunying">
            <div>运营团队介绍</div>
            <div class="xian" v-if="nowPath == '/yunying'"></div>
          </router-link> -->
          <router-link class="menu" to="/anli">
            <div>服务案例</div>
            <div class="xian" v-if="nowPath == '/anli'"></div>
          </router-link>
          <!-- <router-link class="menu" to="/zixun">
            <div>资讯中心</div>
            <div class="xian" v-if="nowPath == '/zixun'"></div>
          </router-link> -->
          <!-- <router-link class="menu" to="/canguan">
            <div>参观报名</div>
            <div class="xian" v-if="nowPath == '/canguan'"></div>
          </router-link> -->
          <router-link class="menu" to="/lianxi">
            <div>联系我们</div>
            <div class="xian" v-if="nowPath == '/lianxi'"></div>
          </router-link>
          <router-link class="menu" to="/guanyu">
            <div>关于亿展</div>
            <div class="xian" v-if="nowPath == '/guanyu'"></div>
          </router-link>
        </div>
      </div>
      <div class="r-k"></div>
    </div>

    <div class="app-head-m" v-if="isMobile">
      <img class="l" src="./assets/logo.png" alt="" />
      <div class="r" @click="drawer = true">
        <i class="el-icon-menu"></i>
      </div>
    </div>

    <el-drawer title="" :visible.sync="drawer" direction="rtl">
      <el-menu
        default-active=""
        class="el-menu-vertical-demo"
        @select="handleOpen"
        background-color="#fff"
        text-color="#1E1E1E"
        active-text-color="#ffffff"
      >
        <el-menu-item index="/">
          <span slot="title">首页</span>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <div class="txt">产品中心</div>
          </template>
          <el-menu-item index="/ruanjian">
            <div class="txt txt-s">软件产品</div>
          </el-menu-item>
          <el-menu-item index="/yingjian">
            <div class="txt txt-s">硬件产品</div>
          </el-menu-item>
          <el-menu-item index="/hujiao">
            <div class="txt txt-s">呼叫中心</div>
          </el-menu-item>
          <el-menu-item index="/zhengjian">
            <div class="txt txt-s">证件印制制作</div>
          </el-menu-item>
          <el-menu-item index="/shuju">
            <div class="txt txt-s">数据分析报告</div>
          </el-menu-item>
          <el-menu-item index="/renyuan">
            <div class="tx txt-st">人员服务</div>
          </el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="/yunying">
          <span slot="title">运营团队介绍</span>
        </el-menu-item> -->
        <el-menu-item index="/anli">
          <span slot="title">服务案例</span>
        </el-menu-item>
        <!-- <el-menu-item index="/zixun">
          <span slot="title">资讯中心</span>
        </el-menu-item> -->
        <!-- <el-menu-item index="/canguan">
          <span slot="title">参观报名</span>
        </el-menu-item> -->
        <el-menu-item index="/lianxi">
          <span slot="title">联系我们</span>
        </el-menu-item>
        <el-menu-item index="/guanyu">
          <span slot="title">关于亿展</span>
        </el-menu-item>
        <!-- <el-menu-item :index="index + 1" v-for="(item,index) in menuList" :key="index">
          <i class="el-icon-menu"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item> -->
      </el-menu>
    </el-drawer>

    <div class="all_bg">
      <div class="app-main">
        <router-view />
      </div>

      <div class="app-foot-bg">
        <div class="footer-bg">
          <div class="app-footer">
            <div class="left">
              <div class="row1">联系电话：18355053505</div>
              <div class="row2">
                <router-link
                  class="row-item"
                  v-for="(item, index) in menuList"
                  :key="index"
                  :to="item.router"
                  >{{ item.name }}</router-link
                >
                
              </div>
            </div>
            <img class="right" src="./assets/ewm.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      menuList: [
        // {
        //   router: "/",
        //   name: "首页",
        // },
        {
          router: "",
          name: "产品中心",
        },
        // {
        //   router: "/yunying",
        //   name: "运营团队介绍",
        // },
        {
          router: "/anli",
          name: "服务案例",
        },
        // {
        //   router: "/zixun",
        //   name: "资讯中心",
        // },
        // {
        //   router: "/canguan",
        //   name: "参观报名",
        // },
        {
          router: "/lianxi",
          name: "联系我们",
        },
        {
          router: "/guanyu",
          name: "关于亿展",
        },
      ],
      nowPath: "",
      isMobile: false,
    };
  },
  watch: {
    // 方法1
    $route(to, from) {
      //监听路由是否变化
      console.log(to.path);
      let wpath = [
        "/ruanjian",
        "/yingjian",
        "/hujiao",
        "/zhengjian",
        "/shuju",
        "/renyuan",
      ];
      if (wpath.indexOf(to.path) > -1) {
        this.nowPath = "/chanpin";
      } else {
        this.nowPath = to.path;
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.resizeFun();
      window.addEventListener("resize", this.resizeFun);
    });
  },
  mounted() {
    // 根据不同路由跳转不同页面
    if (this._isMobile()) {
      console.log("手机端");
      this.isMobile = true;
      localStorage.setItem("isMobile", 1);
      // this.$router.replace('/mb_index')
    } else {
      localStorage.setItem("isMobile", 0);
      console.log("pc端");
      // this.$router.replace('/pc_index', 0)
    }
  },
  methods: {
    resizeFun() {
      const devicePixelRatio = window.devicePixelRatio; // 获取下载的缩放 125% -> 1.25    150% -> 1.5
      if (devicePixelRatio !== 1) {
        // 如果在笔记本中用IE浏览器打开 则弹出提示
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          alert("balabala。。。");
        } else {
          const c = document.querySelector("body");
          c.style.zoom = 1 / devicePixelRatio; // 修改页面的缩放比例
        }
      }
    },

    handleOpen(e, path) {
      if (path.length > 1 && this.$route.path != path[1]) {
        this.$router.replace(path[1]);
      } else if (path.length == 1 && this.$route.path != path[0]) {
        this.$router.replace(path[0]);
      }
      this.drawer = false;
    },

    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>
<style lang="less">

  /* 第二个按钮：了解详情（深蓝色背景） */
.common-btn1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 40px;
  &::after {
    content: ">";
    margin-left: 8px;
    font-weight: bold;
  }
}
.button-learn-more {
  background-color: #182851;
  &::after {
    color: #ffffff;
  }
}
.button-learn-more-bg {
  background: #182851;
  color: #ffffff;
  &::after {
    color: #ffffff;
  }
}

.button-learn-more-yellow {
  background-color: #d18624;
  color: #ffffff;
  &::after {
    color: #ffffff;
  }
}
.button-learn-more-white {
  color: #ffffff;
  border: 1px solid #ffffff;
  &::after {
    color: #ffffff;
  }
}
.app-head-bg {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  // background-color: #080e15;
  height: 106px;
  box-sizing: border-box;
  // box-shadow: 5px 0px 15px 0px #999;

  .l-k {
    flex: 1;
    // background-color: #1f3b95;
  }

  .r-k {
    flex: 1;
  }
}

.app-header {
  display: flex;
  box-sizing: border-box;
  // width: 1440px;
  width: 100%;
  padding: 0 240px;
  flex-shrink: 0;
  color: #182851;
  background: #F2F2F2;
  .logo {
    box-sizing: border-box;
    // background: linear-gradient(-90deg, #4d5da9 0%, #1f3b95 100%);
    flex-shrink: 0;
    padding-right: 30px;
    display: flex;
    align-items: center;
    width: 120px;
    img{
      width: 100%;
    }
  }

  .menu-box {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;

    .menu {
      flex: 1;
      // padding: 0 20px;
      text-align: center;
      font-size: 25px;
      // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
      font-weight: 600;
      color: #182851;
      cursor: pointer;
      text-decoration: none;
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .chanpin {
        position: absolute;
        left: 0;
        // top: -470px;
        top: 106px;
        width: 100%;
        background: #182851;
        border-radius: 0px 0px 20px 20px;
        display: none;
        flex-direction: column;
        box-sizing: border-box;
        padding: 20px 0 20px 15px;
        transition: all 0.5s ease;

        .menu-child {
          cursor: pointer;
          text-decoration: none;
          font-size: 22px;
          // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #ffffff;
          padding: 20px 0;
          text-align: left;
        }
      }

      .xian {
        position: absolute;
        width: 100%;
        bottom: 0;
        height: 12px;
        background-color: #D18523;
        border-radius: 2px;
      }
    }

    .men-c:hover .chanpin {
      display: inline-flex;
      top: 106px;
    }
  }
}
.all_bg {
  width: 100%;
  // background: url("./assets/all_bg.png") no-repeat center top;
  background-size: cover;
}
.app-main {
  width: 100%;
  overflow-y: scroll;
}

.app-foot-bg {
  background: #182851;
}

.app-footer {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 1440px;
  margin: 0 auto;
  height: 231px;
  background: #182851;
  justify-content: space-between;

  .left {
    height: 144px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex: 1;

    .row1 {
      font-size: 25px;
      // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #ffffff;
    }

    .row2 {
      box-sizing: border-box;
      padding-right: 100px;
      display: flex;
      // justify-content: space-between;

      .row-item {
        cursor: pointer;
        text-decoration: none;
        font-size: 25px;
        // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        font-weight: 400;
        color: #fff;
        border-right: #fff 1px solid;
        text-align: center;
        padding: 0 40px;
        line-height: 1;
        &:last-child {
          border-right: none;
        }
        &:first-child {
          padding-left: 0;
        }
      }
      .line{
        display: inline-block;
        width: 1px;
        height: 20px;
        background-color: #fff;
      }
    }
  }

  .right {
    width: 146px;
    height: 144px;
    background-color: #fff;
  }
}

#app {
  box-sizing: border-box;
  background-color: #f2f2f2;
  margin: 0;
  min-width: 1440px;

  .footer-bg {
    width: 100%;
    background: #182851;
    .police {
      width: 1440px;
      margin: 0 auto;
      color: #65686c;
      font-size: 22px;
      padding-bottom: 5%;
      .line1 {
        width: 100%;
        display: flex;
        align-items: center;
        line-height: 2;
        img {
          width: 30px;
          margin-right: 8px;
        }
        .line2 {
          margin-right: 40px;
        }
      }
    }
  }
}

body {
  margin: 0;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
  background-color: transparent;
}
</style>
<style scoped lang='less'>
#app-m {
  .app-head-m {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 120px;
    background: linear-gradient(-90deg, #4d5da9 0%, #1f3b95 100%);
    box-sizing: border-box;
    padding: 0 30px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;

    .l {
      height: 60px;
    }

    .r {
      width: 120px;
      height: 70px;
      border: 2px solid #aeafb1;
      color: rgb(240, 238, 238);
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 50px;
    }
  }

  .app-head-bg {
    display: none;
  }

  .app-foot-bg {
    .app-footer {
      width: 100%;
      height: auto;
      padding: 50px 0;
      display: flex;
      flex-direction: column-reverse;

      .row1 {
        text-align: center;
        margin-top: 20px;
      }

      .row2 {
        width: 100%;
        flex-wrap: wrap;
        padding: 0;
        justify-content: center;

        .row-item {
          padding: 20px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
<style scoped lang='less'>
/deep/ .el-drawer {
  width: 60% !important;
  box-sizing: border-box;
  padding: 0 30px;
  border-radius: 23px !important;

  .el-menu {
    border: none;
  }

  .el-dropdown-menu__item,
  .el-menu-item,
  .el-submenu__title {
    font-size: 40px;
    // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
    font-weight: bold;
    color: #1e1e1e;
  }

  .el-submenu__title,
  .el-menu-item {
    height: 150px;
    line-height: 150px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 80px !important;
    // border-radius: 44px 12px 44px 44px;
    border-radius: 120px 120px 24px 120px;
  }

  .txt-s {
    // color: #686868 !important;
    font-weight: 500;
  }

  .el-menu-item.is-active {
    // background-color: red !important;
    background: linear-gradient(90deg, #263ea8 0%, #3851c0 100%) !important;
    border-radius: 120px 120px 24px 120px;
    // box-shadow: 0px 0px 15px 0 #5B6BF5;
  }

  .el-drawer__close-btn {
    font-size: 50px;
  }
}



</style>


<style>
body {
  /* -webkit-text-size-adjust: 100% !important; */
  /* -webkit-text-size-adjust: none !important; */
}


</style>